import { useEffect, useState } from 'react'
export const useImgLoadingState = (imgSrc: string | undefined) => {
  const [hasError, setImgError] = useState(false)
  const [isLoaded, setIsLoaded] = useState(false)
  useEffect(() => {
    if (imgSrc === undefined) {
      if (hasError || isLoaded) {
        setIsLoaded(false)
        setImgError(false)
      }
      return
    }
    const img = new Image()
    img.onerror = () => setImgError(true)
    img.onload = () => setIsLoaded(true)
    img.src = imgSrc
    return () => {
      img.onerror = null
      img.onload = null
    }
  }, [imgSrc, hasError, isLoaded])
  return { hasError, isLoaded }
}
